import { css } from '@emotion/react';
import { Secondary, p2r } from '../../styles/fonts';
import { ARTICLE_SIDE_INDENT } from '../../styles/vars';
import { colors, breakpoints } from '../../styles';

const { darkOrange, lightBlack, lightGray } = colors;

const styles = (backgroundColorFooter) => css`
  color: ${lightBlack};

  .article__hero-wrapper {
    padding-top: ${p2r(64)};
  }

  .article__image-steps {
    width: 100%;
    min-height: ${p2r(256)};
    object-fit: cover;
    object-position: 50% 70%;

    &--mobile {
      display: none;
    }
  }

  .article__subtitle--yellow {
    color: ${darkOrange};
  }

  .article__posts-block-background {
    width: 100%;
    background-color: ${lightGray};
  }

  .article__posts-block-background-footer {
    background-color: ${backgroundColorFooter};
  }

  .article__posts-block-background--small-size {
    position: absolute;
    z-index: -1;
    min-height: ${p2r(339)};
  }

  .article__block-in-center {
    display: flex;
    justify-content: center;
  }

  .article__posts-block-second {
    padding-bottom: ${p2r(32)};
  }

  .article__posts-text-block {
    padding: ${p2r(48)} 0 0 92px;
    background-color: ${lightGray};
  }

  .strong-word-section__text-container {
    padding: ${p2r(32)} 92px ${p2r(48)} 92px;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .article__posts-block-background--big-size,
    .article__posts-block-background--small-size {
      display: none;
    }

    .article__small-logo {
      padding-left: 18px;
      margin-bottom: ${p2r(16)};
    }

    .article__subtitle--yellow .text-subtitle {
      font-size: ${p2r(24)};
      line-height: ${p2r(32)};
    }

    .article__posts-block-first {
      background-color: ${lightGray};
    }

    .article__hero-wrapper {
      padding-top: 0;
    }
  }

  @media (max-width: ${breakpoints.smallTablet}px) {
    .article__navigation {
      display: none;
    }

    .article__small-logo-text,
    .article__small-logo-image-wrapper {
      display: block;
    }

    .article__small-logo-text {
      padding: 0 0 ${p2r(12)} 0;
      font-size: ${p2r(12)};
    }

    .article__small-logo-image-wrapper > div > a > img {
      max-width: 128px;
    }

    .article__small-logo-image-wrapper > div > a > img,
    .article__small-logo-image-wrapper > div {
      height: ${p2r(32)};
    }

    .article__head {
      position: relative;
      display: flex;
      flex-direction: column;
    }

    .article__hero-wrapper {
      order: 1;
      margin-bottom: ${p2r(16)};
    }

    .article__small-logo {
      order: 2;
      max-width: 90%;
      margin: 0 0 0 ${ARTICLE_SIDE_INDENT};
    }

    .article__posts-block-second .text__all-text--mobile {
      font: normal normal bold ${p2r(36)} / ${p2r(42)} ${Secondary};
    }

    .strong-word-section__text-container {
      padding: ${p2r(32)} 0 0 0;
    }

    .article__posts-text-block {
      padding: ${p2r(33)} 16px;
    }

    .article__subtitle--yellow .text-subtitle {
      font-weight: bold;
    }
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    .article__image-steps {
      min-height: ${p2r(210)};
    }
  }

  @media (max-width: ${breakpoints.mobile}px) {
    .article__image-steps {
      display: none;

      &--mobile {
        display: block;
        width: 100%;
        min-height: ${p2r(210)};
      }
    }

    .article__subtitle--yellow .text-subtitle {
      font-size: ${p2r(28)};
      line-height: ${p2r(32)};
    }

    .article__posts-block-second {
      padding-bottom: ${p2r(64)};
    }
  }
`;

export default styles;
